'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002438 from "./presto.-Agent-View$$anon$38.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$37() {
  this.ayT = null;
  this.ayR = null;
  this.ayS = false;
  this.ayP = null;
  this.ayQ = false;
  this.ayU = false;
  this.ayV = false;
  this.ayT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_AgentView$$anon$37 as $c_Lpresto_AgentView$$anon$37 };
$p = $c_Lpresto_AgentView$$anon$37.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$37;
/** @constructor */
function $h_Lpresto_AgentView$$anon$37() {
}
export { $h_Lpresto_AgentView$$anon$37 as $h_Lpresto_AgentView$$anon$37 };
$h_Lpresto_AgentView$$anon$37.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.ayT;
});
$p.t = (function() {
  if ((!this.ayS)) {
    this.ayR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("files", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ayS = true;
  }
  return this.ayR;
});
$p.ad = (function() {
  if ((!this.ayQ)) {
    this.ayP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().p9(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002438.$c_Lpresto_AgentView$$anon$38()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ayQ = true;
  }
  return this.ayP;
});
$p.v = (function() {
  if ((!this.ayV)) {
    this.ayU = false;
    this.ayV = true;
  }
  return this.ayU;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_AgentView$$anon$37 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$37, "presto.AgentView$$anon$37", ({
  DZ: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$37 as $d_Lpresto_AgentView$$anon$37 };
//# sourceMappingURL=presto.-Agent-View$$anon$37.js.map
